import Local from '@/app/module/local'
import Response from '@/app/model/api/response/responseValue'

class MypagePasswordApi {
  public doMypagePasswordResetting (bodyData: {[key: string]: string}) {
    const path = '/v1/setting/user/password/'

    return fetch(process.env.VUE_APP_API_URL + path, {
      method: 'PUT',
      headers: {
        'X-Auth-Token': Local.getAuthToken()!,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(bodyData)
    })
      .then(response => {
        if (response.status === 200) {
          return response.json()
        } else if (response.status === 400 || response.status === 401 || response.status === 403) {
          return response.json()
        } else {
          throw Error(String(response.status))
        }
      })
      .then(data => {
        if (data.status_code === 0) {
          return new Response(true, {})
        } else {
          throw data
        }
      })
      .catch(e => {
        return new Response(false, e)
      })
  }
}

export default new MypagePasswordApi()
